import { Controller } from "@hotwired/stimulus";
import { headers } from "../utils";

// Connects to data-controller="board-permissions"
export default class extends Controller {
  static targets = ["option", "viewMode"];
  static values = { url: String };

  connect() {}

  change(ev) {
    ev.preventDefault();

    document.body.classList.remove("info-panel-active");

    const data = {};
    this.optionTargets.forEach((el) => {
      data[el.dataset.name] = el.checked;
    });

    fetch(this.urlValue, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify({
        board: { view_permissions: data },
      }),
    })
      .then((resp) => {
        if (!resp.ok) {
          return resp.text().then((html) => {
            window.notyf.error(resp.errors);
          });
        } else {
          resp.text().then((html) => {
            Turbo.renderStreamMessage(html);
          });
        }
      })
      .catch((err) => console.log(err));
  }

  changeDefaultMode(ev) {
    ev.preventDefault();

    document.body.classList.remove("info-panel-active");

    const view_mode = this.viewModeTarget.checked ? "discussion" : "editing";

    fetch(this.urlValue, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify({
        board: { view_mode: view_mode },
      }),
    })
      .then((resp) => {
        if (!resp.ok) {
          return resp.text().then((html) => {
            window.notyf.error(resp.errors);
          });
        } else {
          resp.text().then((html) => {
            Turbo.renderStreamMessage(html);
          });
        }
      })
      .catch((err) => console.log(err));
  }
}
